export default class LoginManagerClass {
    public isLogining = false;
    public goLoginTimer?: NodeJS.Timeout;
    public loginSucCb?: (userIsLogin: any) => void;
    // public loginSucCb = (false);
}

// export const LoginManager = new LoginManagerClass();
